import React, { memo } from 'react'
import { loadersModule } from '../modules/loaders'

const LoaderWithBlur = ({publisherByAbbr, content = ""}) => {
    return (
        <div
            className="page-sign-loader-container"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 9999,
                backdropFilter: 'blur(5px)'
            }}
        >
            <div className="page-sign-loader">{loadersModule(Number(publisherByAbbr))}</div>
            <div className="page-sign-loader-text">
                {content}
            </div>
        </div>
    )
}

export default memo(LoaderWithBlur)
